<template>
  <div class="weight-graph">
    <div class="summary">
      <div class="start">
        <span class="value">
          {{ startingWeight }} kg
        </span>
        <span class="label light">Start</span>
      </div>

      <div class="current">
        <span class="value">
          {{ currentWeight }} kg
        </span>
        <span class="label light">Huidig</span>
      </div>

      <div class="difference" :class="{ negative: currentWeight > startingWeight }">
        <span class="value" v-if="startingWeight !== '--' && currentWeight !== '--'">
          {{ Math.abs(startingWeight - currentWeight).toFixed(1) }} kg
        </span>
        <span class="value" v-else>
          -- kg
        </span>
        <span class="label light">Verschil</span>
      </div>
    </div>
    <div class="chart-container">
      <LineChart v-if="chartData.datasets.length" :chart-data="chartData" :options="chartOptions" />
      <p v-else>Geen gegevens beschikbaar</p>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { LineChart } from "vue-chart-3";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  LineController,
    Filler
} from "chart.js";
import {mapActions} from "vuex";
import {shortDate} from "../../../utils/filters.js";

// ✅ Register all necessary components, including LineController
ChartJS.register(Title, Tooltip, LineElement, PointElement, LinearScale, CategoryScale, LineController, Filler);

export default defineComponent({
  name: "WeightGraph",
  components: { LineChart },
  props: ["weights"],
  data() {
    return {
      startingWeight: "--",
      currentWeight: "--",
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.weights.map((entry) => this.formatDate(entry.created_at) ),
        datasets: [
          {
            label: "Gewicht (kg)",
            data: this.weights.map((entry) => entry.weight),
            borderColor: "#7693a5",
            backgroundColor: "rgba(118, 147, 165, 0.1)",
            fill: true,
            tension: 0.3,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              maxTicksLimit: 5 // Maximum of 3 ticks
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return value + ' kg';
              }
            }
          },
        },
      };
    },
  },
  watch: {
    weights: {
      immediate: true,
      handler(newWeights) {
        if (newWeights.length > 0) {
          this.startingWeight = newWeights[0].weight;
          this.currentWeight = newWeights[newWeights.length - 1].weight;
        } else {
          this.startingWeight = "--";
          this.currentWeight = "--";
        }
      },
    },
  },
  methods: {
    formatDate(date) {
      return shortDate(date); // Use the imported function here
    }
  },
});
</script>